import { Button, Tooltip } from "antd";
import React, { memo, cloneElement } from "react";

const MessageActionButton = memo(({ icon, onClick, disabled, tooltip }) => (
  <Tooltip title={tooltip}>
    <Button
      type="text"
      style={{ backgroundColor: "transparent", border: "none" }}
      icon={cloneElement(icon, {
        style: {
          fontSize: "14px",
          fontWeight: "700"
        }
      })}
      onClick={onClick}
      disabled={disabled}
    />
  </Tooltip>
));

export { MessageActionButton };
